class Settings {
    constructor() {
        (this.settings = {}),
            (this.language = 'sv-se'),
            (this.adultage = 24),
            (this.freetextMaxLength = 150),
            (this.resources = {
                weekdays: ['Söndag','Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
                weekdaysShort: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
                months: [
                    'Januari',
                    'Februari',
                    'Mars',
                    'April',
                    'Maj',
                    'Juni',
                    'Juli',
                    'Augusti',
                    'September',
                    'Oktober',
                    'November',
                    'December',
                ],
                tomorrow: 'Imorgon',
                today: 'Idag',
                next: 'Nästa',
                unknownError: 'Okänt fel',
                apply: 'Ok',
                cancel: 'Avbryt',
                from: 'Från',
                to: 'Till',
                week: 'Vecka',
                weekShort: 'v',
                dateFormat: 'YYYY-MM-DD',
            });

        this.daterange = {
            maxSpan: {
                days: 30,
            },
            locale: {
                format: this.resources.dateFormat,
                separator: ' - ',
                applyLabel: this.resources.apply,
                cancelLabel: this.resources.cancel,
                fromLabel: this.resources.from,
                toLabel: this.resources.to,
                weekLabel: this.resources.weekShort,
                daysOfWeek: this.resources.weekdaysShort,
                monthNames: this.resources.months,
                firstDay: 1,
            },
            opens: 'right',
            timePicker: false,
            minDate: new Date(),
            startDate: new Date(),
            endDate: new Date(),
        };
    }

    init(newSettings) {
        if (newSettings) {
            settings.settings = $.extend(settings.settings, newSettings);
            settings.resources = $.extend(settings.resources, newSettings.resources);
        }
    }
}

export let settings = new Settings();



// WEBPACK FOOTER //
// ./scripts/booking/settings.js